import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseComponent } from '../../../../../../../../models/base/base-component';
import { MasterKushStrainIndexCardStackContentViewModel } from '../master-kush-strain-index-card-stack-content-view-model';

@Component({
  selector: 'app-master-kush-strain-price',
  templateUrl: './master-kush-strain-price.component.html',
  styleUrls: ['./master-kush-strain-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MasterKushStrainPriceComponent extends BaseComponent {
  constructor(public viewModel: MasterKushStrainIndexCardStackContentViewModel) {
    super();
  }

  setupViews() {}
  setupBindings() {}
}
